<template>
    <div>
        <div class="container m-auto p-0" id="hinnatabel">
            <div class="row d-flex justify-content-center m-0 p-0">
                <div class="col-12 m-0 p-0">
                    <div v-if="list" class="row justify-content-center wow fadeIn">
                        <div class="col text-center">
                            <h4 class="dark-grey-text font-weight-normal my-3">{{ list.name[locale] }}</h4>
                        </div>
                    </div>
                    <ul v-if="list" class="nav nav-tabs justify-content-center" role="tablist">
                        <li v-for="(bt, i) in bts" class="nav-item" :key="i">
                            <a @click="pricelistRedirect((bt.name).split(' ').join('.'))" class="btn-link nav-link" :class="{active: pricelist_route === `prices.${(bt.name).split(' ').join('.')}`}">
                                {{ $t(`${bt.name}_plural`) }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a @click="pricelistRedirect('eqs')" class="btn-link nav-link" :class="{active: pricelist_route === 'prices.eqs'}">
                                {{ $t('Additional equipment') }}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a @click="pricelistRedirect('all')" class="btn-link nav-link" :class="{active: pricelist_route === 'prices.all'}">
                                {{ $t('All') }}
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content" v-if="!loading">
                        <router-view name="price-type" :list="list" :bts="bts" :eqs="eqs"/>
                    </div>
                    <p>
                        {{ $t('All prices include VAT') }}
                    </p>
                </div>
            </div>
        </div>
        <app-loader-svg class="mt-4" v-if="loading"/>
    </div>
</template>

<script>
import PublicSettingsService from '@services/publicSettings.service';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            list: null,
            pricelist_route: null,
            bts: [],
            eqs: [],
            loading: true
        };
    },
    computed: {
        ...mapGetters(['envUrl', 'locale'])
    },
    methods: {
        pricelistRedirect(type) {
            localStorage.setItem('pricelist_route', `prices.${type}`);
            this.$router.push({ name: `prices.${type}`, params: { pl_slug: this.list.slug[this.locale] } });
        },
        getPriceList(plSlug) {
            this.loading = true;
            this.pricelist_route = localStorage.getItem('pricelist_route');
            PublicSettingsService.priceList(plSlug).then(res => {
                this.list = res.pl;
                this.bts = res.bts;
                this.eqs = res.eqs;
                if (this.$route.name !== this.pricelist_route) {
                    this.$router.push({name: this.pricelist_route, params:{pl_slug: res.pl.slug[this.locale]}});
                }
                this.loading = false;
            });
        }
    },
    beforeRouteUpdate(to, from, next) {
        this.getPriceList(to.params.pl_slug);
        next();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.getPriceList(to.params.pl_slug);
        });
    }
};
</script>
